export type WindowInterface = Window;

export default window;
